module.exports = "https://static.wagwalking.com/_next/static/images/pet-caregiver-illustration-ee87dcc772a9e8812d072a8f32e40f0e.svg";